import {CreateAccessAdministrationRoleBody} from "@project/sdk/access-administration/zod";
import type {z} from "zod";
import {requiredStringSchema} from "../../../shared/validation/required-string.schema";
import {accessAdministrationFieldMessages} from "../../messages/access-administration.messages";

export const createRoleFormSchema = CreateAccessAdministrationRoleBody.extend({
  name: requiredStringSchema(
    CreateAccessAdministrationRoleBody.shape.name,
    accessAdministrationFieldMessages.roleName.id,
  ),
});
export type CreateRoleFormPayload = z.output<typeof createRoleFormSchema>;
export const draftCreateRoleFormSchema = createRoleFormSchema.partial();
export type DraftCreateRoleFormPayload = z.output<typeof draftCreateRoleFormSchema>;
